/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */

export default {
    path: 'buser',
    component: () => import(/* webpackChunkName: "user-list" */ '@/pages/user/BuserUserList'),
    meta: {title:'B端用户管理'}
  }